var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.907,
    height: 20.935,
    viewBox: "0 0 29.907 20.935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-users",
    "data-name": "Icon awesome-users",
    d: "M4.486,11.222A2.991,2.991,0,1,0,1.5,8.231,2.993,2.993,0,0,0,4.486,11.222Zm20.935,0A2.991,2.991,0,1,0,22.43,8.231,2.993,2.993,0,0,0,25.421,11.222Zm1.5,1.5H23.925a2.982,2.982,0,0,0-2.107.869A6.835,6.835,0,0,1,25.327,18.7h3.084a1.494,1.494,0,0,0,1.5-1.5v-1.5A2.993,2.993,0,0,0,26.916,12.717Zm-11.963,0A5.234,5.234,0,1,0,9.72,7.484,5.231,5.231,0,0,0,14.953,12.717Zm3.589,1.5h-.388a7.226,7.226,0,0,1-6.4,0h-.388A5.385,5.385,0,0,0,5.981,19.6v1.346a2.244,2.244,0,0,0,2.243,2.243H21.682a2.244,2.244,0,0,0,2.243-2.243V19.6A5.385,5.385,0,0,0,18.542,14.213ZM8.089,13.587a2.982,2.982,0,0,0-2.107-.869H2.991A2.993,2.993,0,0,0,0,15.708v1.5a1.494,1.494,0,0,0,1.5,1.5H4.575A6.852,6.852,0,0,1,8.089,13.587Z",
    transform: "translate(0 -2.25)",
    fill: "#716f6f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPublic);
export default __webpack_public_path__ + "static/media/icon-public.07f51f713730d5a4b031ebb078089af1.svg";
export { ForwardRef as ReactComponent };